jQuery(function($) {
    $(document).on("click", '.icon-compare-n a[nj="compare"]', function(event) {
        try {
            var item = $(this).attr('handle');
            if ($(this).attr('nj-compare') != 'added') {
                var values = item + '_' + $j.cookie('nj_Product_compare_test');
                $j.cookie('nj_Product_compare_test', values, {
                    expires: 7,
                    path: '/'
                });
                compProdGetAdded(item);
                getCompItems(item);
            }
            compProdshowMessage();
        } catch (err) {
            console.log(err);
        }
    });
    compProdGetItems($j.cookie('nj_Product_compare_test'));

    function compProdGetItems(c) {
        var d_x = '';
        var d_r = String(c).split("_");
        for (var i = 0; i < d_r.length; i++) {
            if (d_r[i] != null && d_r[i] != 'null' && d_r[i] != '') {
                compProdGetAdded(d_r[i]);
            }
        }
    }

    function compProdGetAdded(c) {
        setTimeout(function() {
            $('.davz_prod_icons a[handle="' + c + '"]').attr('nj-compare', 'added');
        }, 1000);
    }

    function compProdshowMessage() {
        jQuery('#newCompareModal').modal("toggle");
        var count = 0;
        var c = $j.cookie('nj_Product_compare_test');
        var d_r = String(c).split("_");
        for (var i = 0; i < d_r.length; i++) {
            if (d_r[i] != null && d_r[i] != 'null' && d_r[i] != '') {
                count++;
            }
        }
        if (count >= 3) {
            $("#modal-title").text("You Already Have 3 Products to Compare");
            $("#modal-title").css("color", "red");
            $("#modal-subtitle").text("Remove an Existing Product to Add a New Compare");
        } else {
            $("#modal-title").text("Added to Comparison Chart");
            $("#modal-title").css("color", "#000");
            $("#modal-subtitle").text("-Compare up to 3 products-");
        }
    }

    function compProdhideMessage() {
        jQuery('#modalcompProd').modal('hide');
    }
    var cookieName = "nj_Product_compare_test";
    try {
        if ($j.cookie(cookieName) != null && $j.cookie(cookieName) != '_' && $j.cookie(cookieName) != '') {
            var str = String($j.cookie(cookieName)).split("_");
            for (var i = 0; i < str.length; i++) {
                if (str[i] != '' && str[i] != 'null') {
                    getCompItems(str[i]);
                }
            }
        } else {}
    } catch (err) {
        console.log(err);
    }

    function getCompItems(p) {
        var my_result;
        jQuery.getJSON('/products/' + p + '.js', function(product) {
            var my_image = getCompItemsImageFix(product.featured_image);
            var my_title = product.title.replace(/"/g, "&quot;");
            var colors = product.options[0].values;
            var my_color = '';
            for (i = 0; i < colors.length; ++i) {
                my_color += colors[i] + ', ';
            }
            my_color = my_color.substring(0, my_color.lastIndexOf(', '));
            var my_price_min = getCompItemsPrice(product.price_min);
            var my_price_max = getCompItemsPrice(product.price_max);
            var my_compare_at_price_min = getCompItemsPrice(product.compare_at_price_min);
            var my_compare_at_price_max = getCompItemsPrice(product.compare_at_price_max);
            var my_total_color = product.options[0].values.length;
            if (product.compare_at_price_min > product.price_min) {
                if (product.price_min == product.price_max) {
                    var my_price_new = '<span nj="new">' + my_price_min + '</span>';
                } else {
                    my_price_new = '<span nj="new">' + my_price_min + ' to ' + my_price_max + '</span>';
                }
                if (product.compare_at_price_min == product.compare_at_price_max) {
                    var my_price_old = '<span nj="old">' + my_compare_at_price_min + '</span>';
                } else {
                    my_price_old = '<span nj="old">' + my_compare_at_price_min + ' to ' + my_compare_at_price_max + '</span>';
                }
                var my_price = my_price_new + ' ' + my_price_old;
            } else {
                if (product.price_min == product.price_max) {
                    my_price = '<span nj="reg">' + my_price_min + '</span>';
                } else {
                    my_price = '<span nj="reg">' + my_price_min + ' to ' + my_price_max + '</span>';
                }
            }
            var my_brand = product.vendor;
            var my_description = product.description;
            var my_url = product.url;
            var my_handle = product.handle;
            var my_availability = (product.available) ? '<span nj="in-stock">In Stock</span>' : '<span nj="out-of-stock">Out of Stock</span>';
            var my_action = '<label><input type="checkbox" nj-check="" /></label>';
            var sampleimg = product.images;
            var c = 0;
            var d = product.images.length / colors.length;
            var imgs = '<div class="jubs_compare_product_list"><ul class="slider">';
            for (var i = 0; i <= sampleimg.length; i++) {
                if (sampleimg[c] != null && sampleimg[c] != '' && i == c) {
                    imgs += '<li><img src="' + getCompItemsThumbImage(sampleimg[i]) + '" title="' + my_title + '" alt="' + my_title + '"/></li>';
                    c += d;
                }
            }
            imgs += '</ul></div>';
            var images = [];
            for (var i = 0; i < product.variants.length; i++) {
                images.push('<li><img src="' + product.variants[i].featured_image.src.replace(/\.jpg/, '_thumb\.jpg') + '" class="' + my_handle + '" title="' + product.variants[i].option1 + '" alt="' + product.variants[i].option1 + '" /></li>');
            }
            images = '<div class="jubs_compare_product_list"><ul class="slide">' + removeDupsArray(images).join('') + '</ul></div';
            var varimages = '<div class="jbn_wishlist_view_images"><div class="nj_recently_view_slider"><div class="nj_recently_view_flex">' + images + '</div></div></div>';
            var samp = product.images.length;
            var samps = colors.length;
            my_image = '<a href="javascript:void(0);" title="' + my_title + '"><img src="' + my_image + '" title="' + my_title + '" alt="' + my_title + '"/></a>';
            my_title = '<a href="javascript:void(0);" data-dismiss="modal" title="' + my_title + '" onclick="quiqview(\'' + my_handle + '\')">' + my_title + '</a>';
            my_brand = '<span>' + my_brand + '</span>';
            my_total_color = '<span>' + my_total_color + '</span>';
            var my_functions = '<div class="default-wishbutton defbtn' + my_handle + '">' + '<a class="add-in-wishlist-js" href="javascript:void(0)" my-handle=\'' + my_handle + '\' title="ADD TO WISHLIST">' + '<span class="icon icon-favorite_border"></span> ' + '</a>' + '</div>' + '<div class="added-wishbutton" style="display: none;">' + ' <a href="/pages/wishlist"  title="Go to Wishlist">' + '<span class="icon icon-favorite"></span>' + '</a>' + '</div>' + '<div class="qview"><a href="javascript:void(0);" data-dismiss="modal" onclick="quiqview(\'' + my_handle + '\')" title="QUICK VIEW">' + '<span class="simple-icon simple-icon-eye"></span></a></div>' + '<div> <a style="display:block;" href="javascript:void(0);" data-handle="' + my_handle + '" nj="remove" title="REMOVE THIS PRODUCT"><span class="icon icon-delete"></span></a></div>';
            my_result = '<div><div class="content-product-compare">' + '<div class="comp-func">' + my_functions + '</div>' + '<div class="comp-img">' + my_image + '</div>' + '<div class="comp-ptitle">' + my_title + '</div>' + '<div class="comp-price"><b>' + my_price + '</b></div>' + '<div class="comp-desc">' + my_description + '</div>' + '</div></div>';
            $('.compare-carousel').slick('slickAdd', my_result);
            getCompItemsEmpty();
            $('.compare-carousel').slick('refresh');
            $(window).trigger("initWishlistNoCustomer");
        }).error(function() {
            getCompItemsRemove(p);
            jQuery('#newCompareModal').modal('hide');
        });
    }

    function getCompItemsRemove(p) {
        var ck = $j.cookie('nj_Product_compare_test');
        var np = p + '_';
        ck = ck.replace(np, '');
        ck = ck.replace('__', '_');
        $j.cookie('nj_Product_compare_test', ck, {
            expires: 7,
            path: '/'
        });
    }

    function getCompItemsEmpty() {
        if ($('.compare-carousel .slick-track .slick-slide').length) {
            $('.compare-carousel').show();
            $('.comparison-empty').hide();
        } else {
            $('.compare-carousel').hide();
            $('.comparison-empty').show();
        }
    }

    function getCompItemsBtn(c) {
        if (c) {
            $('.nj_products_comparison_table div[nj="filter"] button[nj="btn1"]').attr('nj-check', 'ok');
            $('.nj_products_comparison_table div[nj="filter"] button[nj="btn2"]').attr('nj-check', 'ok');
        } else {
            $('.nj_products_comparison_table div[nj="filter"] button[nj="btn1"]').attr('nj-check', '');
            $('.nj_products_comparison_table div[nj="filter"] button[nj="btn2"]').attr('nj-check', '');
        }
    }

    function getCompItemsImageFix(img) {
        img = img.replace(/\.jpg/g, '_large.jpg');
        img = img.replace(/\.jpeg/g, '_large.jpeg');
        return img;
    }

    function getCompItemsThumbImage(img) {
        img = img.replace(/\.jpg/g, '_thumb.jpg');
        img = img.replace(/\.jpeg/g, '_thumb.jpeg');
        return img;
    }

    function ThumbtoMedImage(img) {
        img = img.replace(/\_thumb.jpg/g, '_large.jpg');
        img = img.replace(/\_thumb.jpeg/g, '_large.jpeg');
        return img;
    }

    function getCompItemsPrice(d) {
        return Shopify.formatMoney(d, "${" + "{amount}}");
    }

    function removeDupsArray(data) {
        return data.filter(function(nj, i, data) {
            return i == data.indexOf(nj);
        });
    }
    $j('.compare-carousel').slick({
        infinite: true,
        dots: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 2,
        swipeToSlide: true,
        responsive: [{
            breakpoint: 1770,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 1199,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    });
    $('.compare-carousel').slick('slickRemove', 0);
    $('.modal').on('shown.bs.modal', function(e) {
//         $("html").css("overflow-y", "hidden");
//         $("html").css("padding-right", "16px");
        $("body").css("padding-right", "0");
        $('.carousel').resize();
    });
    $('.modal').on('hidden.bs.modal', function() {
//         $("html").css("overflow-y", "auto");
        $("html").css("padding-right", "0");
        $(window).resize();
    });
    $(document).on("click", '.davz_new_comparison_icon a', function() {
        getCompItemsEmpty();
    })
    $(document).on("click", '.back-to-compare', function(event) {
        $('#newCompareModal').modal('toggle');
        $('.modal').on('shown.bs.modal', function(e) {
            $('.carousel').resize();
        });
    });
    $(document).on("click", '.comp-img a', function(event) {
        $('#nj_qv_quickViewModal button.close').addClass('back-to-compare');
    });
    $(document).on("click", '.comp-ptitle a', function(event) {
        $('#nj_qv_quickViewModal button.close').addClass('back-to-compare');
    });
    $(document).on("click", '.comp-func .qview a', function(event) {
        $('#nj_qv_quickViewModal button.close').addClass('back-to-compare');
    });
    $(document).on("click", '.comp-func a[nj="remove"]', function(event) {
        var product_handle = $(this).attr('data-handle');
        var rem = $(this).parent().parent().parent().parent().attr('data-slick-index');
        $('.compare-carousel').slick('slickRemove', rem).slick('refresh');
        getCompItemsRemove(product_handle);
        $('a[handle="' + product_handle + '"]').removeAttr('nj-compare');
        getCompItemsEmpty();
    });
    $(document).on("click", 'a span.origin-icon-eye', function(event) {
        $('#nj_qv_quickViewModal button.close').removeClass('back-to-compare');
    });
});